var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',[_c('form-field',{attrs:{"full-width":"","label":"Group Name","name":"group_name"},model:{value:(_vm.group.name),callback:function ($$v) {_vm.$set(_vm.group, "name", $$v)},expression:"group.name"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }